import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRefreshLeft = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M6.36637 6.34902C7.99637 4.71902 10.3064 3.77902 12.8464 4.03902C16.5164 4.40902 19.5364 7.38902 19.9464 11.059C20.4964 15.909 16.7464 19.999 12.0164 19.999C8.82637 19.999 6.08637 18.129 4.80637 15.439C4.48637 14.769 4.96637 13.999 5.70637 13.999C6.07637 13.999 6.42637 14.199 6.58637 14.529C7.71637 16.959 10.4264 18.499 13.3864 17.839C15.6064 17.349 17.3964 15.539 17.8664 13.319C18.7064 9.43902 15.7564 5.99902 12.0164 5.99902C10.3564 5.99902 8.87637 6.68902 7.79637 7.77902L9.30637 9.28902C9.93637 9.91902 9.49637 10.999 8.60637 10.999H5.01637C4.46637 10.999 4.01637 10.549 4.01637 9.99902V6.40902C4.01637 5.51902 5.09637 5.06902 5.72637 5.69902L6.36637 6.34902Z" })
});
export default SvgRefreshLeft;
